import type { FC } from 'react';
import type { Step } from '../lib/types';

const STEPS = ['Data & Description', 'Box Config', 'Results'] as const;

interface Props {
  step: Step;
}

const StepIndicator: FC<Props> = ({ step }) => (
  <div
    style={{ display: 'flex', alignItems: 'center', padding: '14px 24px 0' }}
  >
    {STEPS.map((label, i) => {
      const num = (i + 1) as Step;
      const active = step === num;
      const done = step > num;
      return (
        <div
          key={label}
          style={{
            display: 'flex',
            alignItems: 'center',
            flex: i < STEPS.length - 1 ? 1 : 'none',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 11,
                fontWeight: 700,
                background: done
                  ? '#2563eb'
                  : active
                    ? 'linear-gradient(135deg,#2563eb,#7c3aed)'
                    : '#f1f5f9',
                color: done || active ? '#fff' : '#94a3b8',
                boxShadow: active ? '0 2px 12px #2563eb30' : 'none',
              }}
            >
              {done ? '✓' : num}
            </div>
            <span
              style={{
                fontSize: 9,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                letterSpacing: '0.03em',
                color: active ? '#2563eb' : done ? '#64748b' : '#94a3b8',
              }}
            >
              {label}
            </span>
          </div>
          {i < STEPS.length - 1 && (
            <div
              style={{
                flex: 1,
                height: 1.5,
                margin: '0 6px',
                marginBottom: 16,
                background: done ? '#2563eb' : '#e2e8f0',
              }}
            />
          )}
        </div>
      );
    })}
  </div>
);

export default StepIndicator;
